module.exports = __webpack_public_path__ + "img/premiation-9-viagem-cancun-moto-fan.f1516166.png";